import MuiTableCell, { TableCellProps } from '@mui/material/TableCell';
import classNames from 'classnames';
import type { FC } from 'react';

import styles from './styles.module.scss';

export const TableCell: FC<TableCellProps> = ({ className, ...props }) => (
  <MuiTableCell className={classNames(className, styles.cell)} {...props} />
);
